import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGamepad2 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M8.264 5.18a4.36 4.36 0 0 0-4.276 3.504l-1.78 8.908a1.417 1.417 0 0 0 2.416 1.254L9 14.239a1.09 1.09 0 0 1 .79-.34h5.995a4.36 4.36 0 0 0 0-8.72h-7.52Zm0-2.18a6.54 6.54 0 0 0-6.413 5.257L.07 17.165a3.597 3.597 0 0 0 6.135 3.182l4.053-4.268h5.527a6.54 6.54 0 0 0 0-13.079h-7.52Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M20.912 7.411a1.09 1.09 0 0 1 1.278.862l1.744 8.973a3.597 3.597 0 0 1-6.138 3.163l-4.436-4.67a1.09 1.09 0 1 1 1.58-1.5l4.436 4.669a1.417 1.417 0 0 0 2.418-1.247L20.05 8.69a1.09 1.09 0 0 1 .862-1.278ZM7.61 7.36c.603 0 1.09.488 1.09 1.09v2.18a1.09 1.09 0 0 1-2.18 0V8.45c0-.602.489-1.09 1.09-1.09Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.43 9.54c0-.602.489-1.09 1.09-1.09H8.7a1.09 1.09 0 1 1 0 2.18H6.52a1.09 1.09 0 0 1-1.09-1.09Zm7.63 0c0-.602.488-1.09 1.09-1.09h2.18a1.09 1.09 0 0 1 0 2.18h-2.18a1.09 1.09 0 0 1-1.09-1.09Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGamepad2);
export default ForwardRef;
